import React from "react";

const Behind = () => {
  return (
    <div>
      <div className="w-full relative" style={{ paddingBottom: "56.25%", height: 0 }}>
        <iframe
          className="absolute top-0 left-0 w-full h-full"
          src="https://www.youtube.com/embed/BSEvZqIUzOo?autoplay=1&mute=1"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </div>
  );
};

export default Behind;
